import { type ComponentType } from "react";
import { RequireAuth } from "../../../fabrix/components/authentication/auth-validation";
import { RetryableAfsPage } from "./RetryableAfsPage";

/** Keep import failures inside the authorised route instead of the host error page. */
export function createRetryableAfsRoute(
  loadModule: () => Promise<{ default: ComponentType }>,
  label: string,
) {
  const loadPage = async () => (await loadModule()).default;
  return async () => {
    try {
      const Page = await loadPage();
      return { element: <RequireAuth><Page /></RequireAuth> };
    } catch {
      return {
        element: <RequireAuth><RetryableAfsPage loadPage={loadPage} label={label} initiallyFailed /></RequireAuth>,
      };
    }
  };
}
